import { TransferConfigTypes } from "./types/transfer-config-types";

export const TransferConfig: TransferConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
